module.exports = require('../dist/utils/credit-cards');
